// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckBtnController from "./check_btn_controller.js"
application.register("check-btn", CheckBtnController)

import ExportMaterialController from "./export_material_controller.js"
application.register("export-material", ExportMaterialController)

import GoodsStockController from "./goods_stock_controller.js"
application.register("goods-stock", GoodsStockController)

import GoodsStockReceiveController from "./goods_stock_receive_controller.js"
application.register("goods-stock-receive", GoodsStockReceiveController)

import ImportGoodsStockController from "./import_goods_stock_controller.js"
application.register("import-goods-stock", ImportGoodsStockController)

import ImportMaterialsStockController from "./import_materials_stock_controller.js"
application.register("import-materials-stock", ImportMaterialsStockController)

import InhouseItemController from "./inhouse_item_controller.js"
application.register("inhouse-item", InhouseItemController)

import ItemController from "./item_controller.js"
application.register("item", ItemController)

import LeaderController from "./leader_controller.js"
application.register("leader", LeaderController)

import MaterialController from "./material_controller.js"
application.register("material", MaterialController)

import MaterialProductController from "./material_product_controller.js"
application.register("material-product", MaterialProductController)

import MaterialsStockController from "./materials_stock_controller.js"
application.register("materials-stock", MaterialsStockController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import PackingController from "./packing_controller.js"
application.register("packing", PackingController)

import PickItemController from "./pick_item_controller.js"
application.register("pick-item", PickItemController)

import PocController from "./poc_controller.js"
application.register("poc", PocController)

import PolController from "./pol_controller.js"
application.register("pol", PolController)

import PolsItemDetailController from "./pols_item_detail_controller.js"
application.register("pols-item-detail", PolsItemDetailController)

import ProductController from "./product_controller.js"
application.register("product", ProductController)

import QcController from "./qc_controller.js"
application.register("qc", QcController)

import ReceiveItemController from "./receive_item_controller.js"
application.register("receive-item", ReceiveItemController)

import ReceiveReportController from "./receive_report_controller.js"
application.register("receive-report", ReceiveReportController)

import ReportController from "./report_controller.js"
application.register("report", ReportController)

import ShipmentController from "./shipment_controller.js"
application.register("shipment", ShipmentController)

import ShippingController from "./shipping_controller.js"
application.register("shipping", ShippingController)

import SpinnerController from "./spinner_controller.js"
application.register("spinner", SpinnerController)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)
